/**
 * @generated SignedSource<<0e0d1ef8d96795a5ae26e4e46076a222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_SidebarLayout_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project">;
  readonly " $fragmentType": "main_issueNavigator_SidebarLayout_project";
};
export type main_issueNavigator_SidebarLayout_project$key = {
  readonly " $data"?: main_issueNavigator_SidebarLayout_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_SidebarLayout_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_SidebarLayout_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        },
        {
          "kind": "Variable",
          "name": "isSavedViewConditionalFormattingEnabled",
          "variableName": "isSavedViewConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "9bc206d240f48026ed29dd23bb0b3787";

export default node;
